// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchMessages__container-b3b061 {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 360px;
  position: relative;
  border-left: 1px solid var(--base-20);
  background-color: var(--base-0);
}

.SearchMessages__placeholders-eeb2c0 {
  padding: 8px 16px;
}

.SearchMessages__header-d89362 {
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.SearchMessages__title-a64a42 {
  margin-inline-end: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
}

.SearchMessages__search-e3b88d {
  margin: 8px 15px;
  min-height: 40px;
}

.SearchMessages__list-e4feb0 {
  flex: 1;
  overflow: hidden;
}

.SearchMessages__results-d41f0f,
.SearchMessages__no-results-c11407 {
  height: 100%;
}

.SearchMessages__no-results-c11407 {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.SearchMessages__loader-d043d9 {
  margin-inline-end: 6px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/SearchMessages/SearchMessages.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AACF;;AAEA;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,OAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,YAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,4BAAA;EACA,8CAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,sBAAA;AACF","sourcesContent":[".container {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  width: 360px;\n  position: relative;\n  border-left: 1px solid var(--base-20);\n  background-color: var(--base-0);\n}\n\n.placeholders {\n  padding: 8px 16px;\n}\n\n.header {\n  display: flex;\n  min-height: 72px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n}\n\n.title {\n  margin-inline-end: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n}\n\n.search {\n  margin: 8px 15px;\n  min-height: 40px;\n}\n\n.list {\n  flex: 1;\n  overflow: hidden;\n}\n\n.results,\n.no-results {\n  height: 100%;\n}\n\n.no-results {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.loader {\n  margin-inline-end: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SearchMessages__container-b3b061`,
	"placeholders": `SearchMessages__placeholders-eeb2c0`,
	"header": `SearchMessages__header-d89362`,
	"title": `SearchMessages__title-a64a42`,
	"search": `SearchMessages__search-e3b88d`,
	"list": `SearchMessages__list-e4feb0`,
	"results": `SearchMessages__results-d41f0f`,
	"no-results": `SearchMessages__no-results-c11407`,
	"noResults": `SearchMessages__no-results-c11407`,
	"loader": `SearchMessages__loader-d043d9`
};
module.exports = ___CSS_LOADER_EXPORT___;
